import axios from 'axios';
import config from 'config';

export const urls = {
  register: '/v3/register',
  googleSSO: '/v3/google-sso',
};

const api = axios.create({
  baseURL: config.apiUrl,
});

export default api;
